export enum DailyGapsQuickAction {
	LOCATION = "Edit Location",
	TIME = "Edit Time",
	NOTE = "Edit Notes",
	REMOVE = "Remove Shift",
	EDIT_RECURRING = "Edit Recurring Shift",
}
